import { type Location } from '@koala/sdk';
import Link from 'next/link';
import { StyledButton } from './styles';
import { useSelector } from '@/redux';
import { fireGaEvent, gaActions, gaCats } from '@/utils/googleAnalytics';
import { getLocationId } from '@/utils/locations';

interface Props {
  location: Location;
  label: string;
  favorites?: boolean;
}

function MenuCta({ location, label }: Props) {
  const { webConfig } = useSelector((state) => state.app.cmsConfig);

  return (
    <Link
      href={`/store/${getLocationId(location, webConfig)}/${location.label}`}
      passHref={true}
      legacyBehavior
    >
      <StyledButton
        as="a"
        $buttonTheme="primary"
        onClick={() => {
          fireGaEvent(gaCats.order, gaActions.viewMenu, {
            label: location.label,
          });
        }}
      >
        {label}
      </StyledButton>
    </Link>
  );
}

export default MenuCta;
